package com.tovtalk.ui

import androidx.compose.runtime.staticCompositionLocalOf

/**
 * CompositionLocal for "app in foreground" – when false, video should pause (e.g. on Android onStop).
 * Default is true so that platforms that don't set it (iOS, Web) keep playing when visible.
 * Android MainActivity sets this to false in onStop and true in onStart.
 */
val LocalAppInForeground = staticCompositionLocalOf { true }
